export enum StakingActionTypeEnums {
  Stake,
  Unstake,
  Claim,
}

export const FETCH_POOL_STATS_INTERVAL = 30000
